import { render, staticRenderFns } from "./history.vue?vue&type=template&id=49008f90&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49008f90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49008f90')) {
      api.createRecord('49008f90', component.options)
    } else {
      api.reload('49008f90', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=49008f90&scoped=true", function () {
      api.rerender('49008f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/send/history.vue"
export default component.exports